import { 
    FETCH_BRANDKIT_FONTS_REQUEST, FETCHING_BRANDKIT_FONTS_SUCCEEDED, FETCHING_BRANDKIT_FONTS_FAILED,
    INITIATE_BRANDKIT_FONT_UPLOAD, UPDATE_BRANDKIT_FONT_UPLOAD_PROGRESS, 
    INSTALL_BRANDKIT_FONTS, UNINSTALL_BRANDKIT_FONTS, INVALIDATE_BRANDKIT_FONT_UPLOAD_ERROR,
    UPLOAD_BRANDKIT_FONT_REQUEST, UPLOADING_BRANDKIT_FONT_SUCCEEDED, UPLOADING_BRANDKIT_FONT_FAILED,
    DELETE_BRANDKIT_FONT_REQUEST, DELETING_BRANDKIT_FONT_SUCCEEDED, DELETING_BRANDKIT_FONT_FAILED,

    CREATE_BRANDKIT_TEXT, DELETE_BRANDKIT_TEXT, UPDATE_BRANDKIT_TEXT_PROPERTY, 
    RENAME_BRANDKIT_TEXT, UPDATE_BRANDKIT_TEXT_CONTENT, ASSOCIATE_FONTS_WITH_BRANDKIT_TEXT,
    FETCHING_BRANDKIT_TEXT_REQUEST, FETCHING_BRANDKIT_TEXT_SUCCEEDED, FETCHING_BRANDKIT_TEXT_FAILED,
    DELETE_BRANDKIT_TEXT_REQUEST, DELETING_BRANDKIT_TEXT_SUCCEEDED, DELETING_BRANDKIT_TEXT_FAILED,
    UPDATE_BRANDKIT_TEXT_REQUEST, UPDATING_BRANDKIT_TEXT_SUCCEEDED, UPDATING_BRANDKIT_TEXT_FAILED,
    INVALIDATE_BRANDKIT_TEXT
  } from 'constants/actionTypes';
  
  import { call, put, takeEvery } from 'redux-saga/effects';
  import axios from 'axios';
  import { createAction } from 'redux-actions';
  import buildUrl from 'build-url';
  
  const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
  const BRANDKIT_FONT_URL = `${apiUrl}/api/2.0/fonts`;
  const BRANDKIT_TEXT_URL = `${apiUrl}/api/2.0/palette`;
  
  export const fetchBrandkitFonts = createAction(FETCH_BRANDKIT_FONTS_REQUEST);
  
  const fetchingBrandkitFontsSucceeded = createAction(FETCHING_BRANDKIT_FONTS_SUCCEEDED, (response) => {
    return response;
  })
  
  const fetchingBrandkitFontsFailed = createAction(FETCHING_BRANDKIT_FONTS_FAILED, (error) => {
    return error;
  });
  
  function* fetchBrandkitFontsSaga(action) {
    const {page, limit}  = action.payload

    let url = buildUrl(BRANDKIT_FONT_URL, {
      path: `/all`,
      queryParams: {
        page,
        limit,
      }
    });

    const fetchBrandkitFontsAPI = () => {
      return axios.post(url, {}).then(response => response.data);
    }
  
    try {
      const response = yield call(fetchBrandkitFontsAPI);
      yield put(fetchingBrandkitFontsSucceeded(response));
    } catch (error) {
      yield put(fetchingBrandkitFontsFailed(error));
    }
  }
  
  /**
   * Create BrandkitFont
  */
  export const initiateBrandkitFontUpload = createAction(INITIATE_BRANDKIT_FONT_UPLOAD, (request) => {
    return request;
  });
  
  export const updateBrandkitFontUploadProgress = createAction(UPDATE_BRANDKIT_FONT_UPLOAD_PROGRESS, (id, progress) => {
    return {id, progress};
  });
  
  export const uploadBrandkitFont = createAction(UPLOAD_BRANDKIT_FONT_REQUEST, (id, request) => {
    return {id, request};
  })
  
  export const uploadingBrandkitFontSucceeded = createAction(UPLOADING_BRANDKIT_FONT_SUCCEEDED, (id, response) => {
    return {id, response};
  })
  
  export const uploadingBrandkitFontFailed = createAction(UPLOADING_BRANDKIT_FONT_FAILED, (id, error) => {
    return {id, error};
  })
  
  function* uploadBrandkitFontSaga(action) {
    const {id, request} = action.payload;
  
    const uploadBrandkitFontAPI = () => {
      return axios.post(BRANDKIT_FONT_URL, request).then(response => response.data);
    }
  
    try {
      const response = yield call(uploadBrandkitFontAPI);
      if (response) {
        yield put(uploadingBrandkitFontSucceeded(id, response));
      }
    } catch (error) {
      yield put(uploadingBrandkitFontFailed(id, error));
    }
  }
  
  /**
   * Delete BrandkitFont
   * 
  */
  export const deleteBrandkitFont = createAction(DELETE_BRANDKIT_FONT_REQUEST, (ids) => {
    return ids;
  })
  
  export const deletingBrandkitFontSucceeded = createAction(DELETING_BRANDKIT_FONT_SUCCEEDED, (ids, response) => {
    return { ids, response };
  })
  
  export const deletingBrandkitFontFailed = createAction(DELETING_BRANDKIT_FONT_FAILED, (ids, error) => {
    return {ids, error};
  })
  
  function* deleteBrandkitFontSaga(action) {
    const ids = action.payload;
  
    const url = buildUrl(BRANDKIT_FONT_URL);
  
    const deleteBrandkitFontAPI = () => {
      return axios.delete(url, {data: ids}).then(response => response.data);
    }
  
    try {
      const response = yield call(deleteBrandkitFontAPI);
      yield put(deletingBrandkitFontSucceeded(ids, response));
    } catch (error) {
      yield put(deletingBrandkitFontFailed(ids, error));
    }
  }
  
  export const invalidateBrandkitFontUploadError = createAction(INVALIDATE_BRANDKIT_FONT_UPLOAD_ERROR);
  
  export const installBrandkitFonts = createAction(INSTALL_BRANDKIT_FONTS, (fonts) => {
    return fonts;
  });
  
  export const uninstallBrandkitFonts = createAction(UNINSTALL_BRANDKIT_FONTS, (fonts) => {
    return fonts;
  });


  export const createBrandkitText = createAction(CREATE_BRANDKIT_TEXT, (component) => {
    return {
      component: component
    };
  });

  export const deleteBrandkitNewText = createAction(DELETE_BRANDKIT_TEXT, (ids) => {
    return {
      ids: ids
    };
  });

  export const updateBrandkitTextProperty = createAction(UPDATE_BRANDKIT_TEXT_PROPERTY, (id, widget_uid, property) => {
    return {
      id: id,
      widget_uid: widget_uid,
      property: property
    };
  });

  export const updateBrandkitTextContent = createAction(UPDATE_BRANDKIT_TEXT_CONTENT, (id, widget_uid, content) => {
    return {
      id: id,
      widget_uid: widget_uid,
      content: content
    };
  });

  export const associateFontWithBrandkitText = createAction(ASSOCIATE_FONTS_WITH_BRANDKIT_TEXT, (id, widget_uid, fonts) => {
    return {
      id: id,
      widget_uid: widget_uid,
      fonts: fonts
    };
  });

  export const renameBrandkitText = createAction(RENAME_BRANDKIT_TEXT, (id, name) => {
    return {
      id: id,
      name: name
    };
  });
  
  /**
   * Fetch Brankit Text
  */
    export const fetchBrandkitText = createAction(FETCHING_BRANDKIT_TEXT_REQUEST, id => {
      return id;
    })
    
    const fetchBrandkitTextSucceeded = createAction(FETCHING_BRANDKIT_TEXT_SUCCEEDED, response => {
      return response;
    })
    
    const fetchingBrandkitTextFailed = createAction(FETCHING_BRANDKIT_TEXT_FAILED, (id, error) => {
      return {
        id: id,
        error: error
      }
    })
    
    function* fetchingBrandkitTextSaga(action) {
      const id = action.payload;
    
      let url = buildUrl(BRANDKIT_TEXT_URL, {
        path: id
      });
    
      const fetchingBrandkitTextAPI = () => {
        return axios.get(url).then(response => response.data);
      }
    
      try {
        const response = yield call(fetchingBrandkitTextAPI);
        yield put(fetchBrandkitTextSucceeded(response));
      } catch (error) {
        yield put(fetchingBrandkitTextFailed(id, error));
      }
    }
  
  
  /**
   * Update Brankit colors
  */
    export const updateBrandkitText = createAction(UPDATE_BRANDKIT_TEXT_REQUEST, (id, request) => {
      return {
        id: id,
        request: request
      }
    })
    
    export const updateBrandkitTextSucceeded = createAction(UPDATING_BRANDKIT_TEXT_SUCCEEDED, (response) => {
      return {
        response: response
      }
    })
    
    export const updateBrandkitTextFailed = createAction(UPDATING_BRANDKIT_TEXT_FAILED, (id, error) => {
      return {
        id: id,
        error: error
      }
    })
    
    function* updateBrandkitTextSaga(action) {
      const { id, request } = action.payload;
          
      let url = buildUrl(BRANDKIT_TEXT_URL, {
        path: `/${id}`
      });
    
      const updateBrandkitTextAPI = () => {
        return axios.put(url, {components: request}).then(response => response.data);
      }

      try {
        const response = yield call(updateBrandkitTextAPI);
        if (response) {
          yield put(updateBrandkitTextSucceeded(response));
        }
      } catch (error) {
        yield put(updateBrandkitTextFailed(error));
      }
    }
  
  
  /**
   * Delete Brandkit colors
  */
    export const deleteBrandkitText = createAction(DELETE_BRANDKIT_TEXT_REQUEST, (ids, paletteId) => {
      return {
        ids: ids,
        paletteId: paletteId
      }
    }) 
    
    const deleteBrandkitTextSucceeded = createAction(DELETING_BRANDKIT_TEXT_SUCCEEDED, (ids, response) => {
      return {
        ids: ids,
        response: response
      }
    })
    
    const deleteBrandkitTextFailed = createAction(DELETING_BRANDKIT_TEXT_FAILED, (ids, error) => {
      return {
        ids: ids,
        error: error
      }
    })
    
    function* deleteBrandkitTextSaga(action) {
      const {ids, paletteId} = action.payload;
    
      let url = buildUrl(BRANDKIT_TEXT_URL, {
        path: `${paletteId}/component`
      });
    
      const deleteBrandkitTextAPI = () => {
        return axios.delete(url, {data: ids}).then(response => response.data);
      }
    
      try {
        const response = yield call(deleteBrandkitTextAPI);
        yield put(deleteBrandkitTextSucceeded(ids, response));
      } catch (error) {
        yield put(deleteBrandkitTextFailed(ids, error));
      }
    }

    export const invalidateBrandkitText = createAction(INVALIDATE_BRANDKIT_TEXT);

  
  export default function* brandKitTextSaga() {
    yield takeEvery(FETCH_BRANDKIT_FONTS_REQUEST, fetchBrandkitFontsSaga);
    yield takeEvery(UPLOAD_BRANDKIT_FONT_REQUEST, uploadBrandkitFontSaga);
    yield takeEvery(DELETE_BRANDKIT_FONT_REQUEST, deleteBrandkitFontSaga);

    yield takeEvery(FETCHING_BRANDKIT_TEXT_REQUEST, fetchingBrandkitTextSaga);
    yield takeEvery(DELETE_BRANDKIT_TEXT_REQUEST, deleteBrandkitTextSaga);
    yield takeEvery(UPDATE_BRANDKIT_TEXT_REQUEST, updateBrandkitTextSaga);
  }